import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIDuyetDoiTruong = {
  LIST_HO_SO: `${BASE_API_URL_CAP_DIEN}/ho-so/list`,
  CREATE_HO_SO: `${BASE_API_URL_CAP_DIEN}/ho-so/create`,
  UPDATE_HO_SO: `${BASE_API_URL_CAP_DIEN}/ho-so/update`,
  REMOVE_HO_SO: `${BASE_API_URL_CAP_DIEN}/ho-so/delete`,
};
